import React, { type ReactNode, forwardRef, type MouseEventHandler } from 'react';
import { style } from 'typestyle';
import flex from './flex.styles';
import mergeClasses from '../../utils/merge-classes';

export enum MainAxisAlignment {
  SpaceAround = 'space-around',
  SpaceBetween = 'space-between',
  SpaceEvenly = 'space-evenly',
  Stretch = 'stretch',
  Start = 'flex-start',
  End = 'flex-end',
  Center = 'center',
}

export enum CrossAxisAlignment {
  Stretch = 'stretch',
  Start = 'flex-start',
  End = 'flex-end',
  Center = 'center',
}

export enum FlexDirection {
  Column = 'column',
  Row = 'row',
  ColumnReverse = 'column-reverse',
  RowReverse = 'row-reverse',
}

export enum FlexWrap {
  NoWrap = 'nowrap',
  Wrap = 'wrap',
  WrapReverse = 'wrap-reverse',
}

export interface FlexProps {
  readonly itemSpacing?: number;
  readonly wrapSpacing?: number;
  readonly mainAxisAlignment?: MainAxisAlignment;
  readonly crossAxisAlignment?: CrossAxisAlignment;
  readonly wrap?: FlexWrap;
  readonly className?: string;
  readonly children: ReactNode;
  readonly onClick?: MouseEventHandler;
}

interface Props extends FlexProps {
  readonly direction: FlexDirection;
}

export const Flex = forwardRef<HTMLDivElement, Props>(
  ({ direction, itemSpacing, wrapSpacing, mainAxisAlignment, crossAxisAlignment, wrap, className, children, onClick }, ref) => (
    <div
      ref={ref}
      className={mergeClasses(className, style(flex(direction, itemSpacing, wrapSpacing, crossAxisAlignment, mainAxisAlignment, wrap)))}
      onClick={onClick}
      role="presentation"
    >
      {children}
    </div>
  ),
);
